import './index.css';
import { useState, useCallback } from 'react';

const useFocus = (onChange, onFocus, onBlur) => {
    const [isFocused, setFocused] = useState(false);
    const changeHandler = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    const focusHandler = useCallback((event) => {
        setFocused(true);
        onFocus?.(event);
    }, [setFocused, onFocus]);
    const blurHandler = useCallback((event) => {
        setFocused(false);
        onBlur?.(event);
    }, [setFocused, onBlur]);
    return { changeHandler, focusHandler, blurHandler, isFocused };
};

export { useFocus };
//# sourceMappingURL=useFocus.js.map
